//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class TablePagedResultOfAgentSubscription {
    data : AgentSubscription[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class BaseEntity {
    identifier : string;
    createdOn : string ;
    modifiedOn : string ;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.createdOn = null;
                                this.modifiedOn = null;
                    }
}

export class AgentSubscription extends BaseEntity {
    number : string;
    user : NameIdentifier;
    startFrom : string ;
    expiresOn : string ;
    purchaseIdentifier : string;
    contracts : Attachment[];
    contractSignedOn : string ;
    generatedOtpForSigning : string;

    constructor() 
    {
            	        super();
		                        this.number = "" ;
                                this.user = new NameIdentifier();
                                this.startFrom = null;
                                this.expiresOn = null;
                                this.purchaseIdentifier = "" ;
                                this.contracts = [];
                                this.contractSignedOn = null;
                                this.generatedOtpForSigning = "" ;
                    }
}

export class NameIdentifier {
    identifier : string;
    name : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.name = "" ;
                    }
}

export class Attachment {
    identifier : string;
    filename : string;
    path : string;
    mimeType : string;
    publicUrl : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.filename = "" ;
                                this.path = "" ;
                                this.mimeType = "" ;
                                this.publicUrl = "" ;
                    }
}

export class BasePagedRequest {
    pageNumber : number;
    perPage : number;
    sortBy : SortByParameter;

    constructor() 
    {
            	                        this.pageNumber = null ;
                                this.perPage = null ;
                                this.sortBy = new SortByParameter();
                    }
}

export class AgentSubscriptionListFilterVm extends BasePagedRequest {
    createdOnFrom : string ;
    createdOnTo : string ;
    number : string;
    startFromFrom : string ;
    startFromTo : string ;
    expiresOnFrom : string ;
    expiresOnTo : string ;
    user : string;

    constructor() 
    {
            	        super();
		                        this.createdOnFrom = null;
                                this.createdOnTo = null;
                                this.number = "" ;
                                this.startFromFrom = null;
                                this.startFromTo = null;
                                this.expiresOnFrom = null;
                                this.expiresOnTo = null;
                                this.user = "" ;
                    }
}

export class SortByParameter {
    propertyName : string;
    ascending : boolean;

    constructor() 
    {
            	                        this.propertyName = "" ;
                                this.ascending = false ;
                    }
}

export class AddAgentSubscriptionVm {
    userIdentifier : string;
    days : number;

    constructor() 
    {
            	                        this.userIdentifier = "" ;
                                this.days = null ;
                    }
}

export class TablePagedResultOfAgentSubscriptionRequest {
    data : AgentSubscriptionRequest[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class AgentSubscriptionRequest extends BaseEntity {
    user : NameIdentifier;
    comments : Comment[];
    approvedOn : string ;

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.comments = [];
                                this.approvedOn = null;
                    }
}

export class Comment {
    identifier : string;
    createdOn : string ;
    author : NameIdentifier;
    text : string;
    attachments : Attachment[];

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.createdOn = null;
                                this.author = new NameIdentifier();
                                this.text = "" ;
                                this.attachments = [];
                    }
}

export class AgentSubscriptionRequestListFilterVm extends BasePagedRequest {
    createdOnFrom : string ;
    createdOnTo : string ;
    approvedOnFrom : string ;
    approvedOnTo : string ;
    user : string;

    constructor() 
    {
            	        super();
		                        this.createdOnFrom = null;
                                this.createdOnTo = null;
                                this.approvedOnFrom = null;
                                this.approvedOnTo = null;
                                this.user = "" ;
                    }
}

export class BaseBackendNotification extends BaseEntity {
    user : NameIdentifier;
    readOn : string ;
    type : string;

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.readOn = null;
                                this.type = "" ;
                    }
}

export class BackendRoleConfig extends BaseEntity {
    name : string;
    permissionRole : string;
    isDefault : boolean;
    receiveNetworkChatNotifications : boolean;
    limitedToVillage : NameIdentifier;
    clientModules : ClientModuleConfiguration[];

    constructor() 
    {
            	        super();
		                        this.name = "" ;
                                this.permissionRole = "" ;
                                this.isDefault = false ;
                                this.receiveNetworkChatNotifications = false ;
                                this.limitedToVillage = new NameIdentifier();
                                this.clientModules = [];
                    }
}

export class ClientModuleConfiguration {
    name : string;
    isNavigationEntry : boolean;

    constructor() 
    {
            	                        this.name = "" ;
                                this.isNavigationEntry = false ;
                    }
}

export class TablePagedResultOfCard {
    data : Card[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class Card extends BaseEntity {
    nameOnCard : string;
    cardNumber : string;
    cvv : string;
    providerAccountId : string;
    providerCardId : string;
    expiresOn : string ;
    user : NameIdentifier;

    constructor() 
    {
            	        super();
		                        this.nameOnCard = "" ;
                                this.cardNumber = "" ;
                                this.cvv = "" ;
                                this.providerAccountId = "" ;
                                this.providerCardId = "" ;
                                this.expiresOn = null;
                                this.user = new NameIdentifier();
                    }
}

export class CardListFilterVm extends BasePagedRequest {
    createdOnFrom : string ;
    createdOnTo : string ;
    cardNumber : string;
    wallesterAccountId : string;
    wallesterCardId : string;
    expiresOnFrom : string ;
    expiresOnTo : string ;
    user : string;

    constructor() 
    {
            	        super();
		                        this.createdOnFrom = null;
                                this.createdOnTo = null;
                                this.cardNumber = "" ;
                                this.wallesterAccountId = "" ;
                                this.wallesterCardId = "" ;
                                this.expiresOnFrom = null;
                                this.expiresOnTo = null;
                                this.user = "" ;
                    }
}

export class Transaction {
    account_amount : number;
    account_currency_code : string;
    acquirer_business_id : string;
    acquirer_reference_number : string;
    authorization_code : string;
    authorization_id : string;
    card_id : string;
    central_processing_date : string ;
    created_at : string ;
    exchange_rate : number;
    group : string;
    has_payment_document_files : boolean;
    has_payment_notes : boolean;
    id : string;
    is_failed : boolean;
    marked_for_dispute_at : string ;
    marked_for_dispute_by : string;
    merchant_category_code : string;
    merchant_city : string;
    merchant_country_code : string;
    merchant_id : string;
    merchant_name : string;
    merchant_postal_code : string;
    processed_at : string ;
    purchase_date : string ;
    terminal_id : string;
    total_amount : number;
    transaction_amount : number;
    transaction_code : string;
    transaction_currency_code : string;
    transaction_identifier : string;

    constructor() 
    {
            	                        this.account_amount = null ;
                                this.account_currency_code = "" ;
                                this.acquirer_business_id = "" ;
                                this.acquirer_reference_number = "" ;
                                this.authorization_code = "" ;
                                this.authorization_id = "" ;
                                this.card_id = "" ;
                                this.central_processing_date = null;
                                this.created_at = null;
                                this.exchange_rate = null ;
                                this.group = "" ;
                                this.has_payment_document_files = false ;
                                this.has_payment_notes = false ;
                                this.id = "" ;
                                this.is_failed = false ;
                                this.marked_for_dispute_at = null;
                                this.marked_for_dispute_by = "" ;
                                this.merchant_category_code = "" ;
                                this.merchant_city = "" ;
                                this.merchant_country_code = "" ;
                                this.merchant_id = "" ;
                                this.merchant_name = "" ;
                                this.merchant_postal_code = "" ;
                                this.processed_at = null;
                                this.purchase_date = null;
                                this.terminal_id = "" ;
                                this.total_amount = null ;
                                this.transaction_amount = null ;
                                this.transaction_code = "" ;
                                this.transaction_currency_code = "" ;
                                this.transaction_identifier = "" ;
                    }
}

export class ChatRoom extends BaseEntity {
    disabled : boolean;
    village : NameIdentifier;
    user : NameIdentifier;
    newMessagesForUser : boolean;
    newMessagesForBackoffice : boolean;
    lastReadForUser : string ;
    lastReadForBackoffice : string ;
    subscribers : string[];
    lastMessage : ChatMessage;
    topic : string;

    constructor() 
    {
            	        super();
		                        this.disabled = false ;
                                this.village = new NameIdentifier();
                                this.user = new NameIdentifier();
                                this.newMessagesForUser = false ;
                                this.newMessagesForBackoffice = false ;
                                this.lastReadForUser = null;
                                this.lastReadForBackoffice = null;
                                this.subscribers = [];
                                this.lastMessage = new ChatMessage();
                                this.topic = "" ;
                    }
}

export class ChatMessage extends BaseEntity {
    chatIdentifier : string;
    timestamp : number;
    sender : string;
    senderIdentifier : string;
    text : string;
    fromBackend : boolean;
    quotedMessage : QuotedMessage;

    constructor() 
    {
            	        super();
		                        this.chatIdentifier = "" ;
                                this.timestamp = null ;
                                this.sender = "" ;
                                this.senderIdentifier = "" ;
                                this.text = "" ;
                                this.fromBackend = false ;
                                this.quotedMessage = new QuotedMessage();
                    }
}

export class QuotedMessage {
    sender : string;
    text : string;
    fromBackend : boolean;

    constructor() 
    {
            	                        this.sender = "" ;
                                this.text = "" ;
                                this.fromBackend = false ;
                    }
}

export class HasNewChatMessagesVm {
    network : boolean;
    villages : { [key: string]: boolean; };

    constructor() 
    {
            	                        this.network = false ;
                                this.villages = {};
                    }
}

export class TablePagedResultOfChatRoom {
    data : ChatRoom[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class TicketListFilterVm extends BasePagedRequest {
    createdOn : string ;
    onlyToRead : boolean;
    villageIdentifier : string;
    isVillageRequest : boolean;
    hasMessages : boolean;
    user : string;

    constructor() 
    {
            	        super();
		                        this.createdOn = null;
                                this.onlyToRead = false ;
                                this.villageIdentifier = "" ;
                                this.isVillageRequest = false ;
                                this.hasMessages = false ;
                                this.user = "" ;
                    }
}

export class RemoveChatMessagesVm {
    chatRoomIdentifier : string;
    messagesIdentifier : string[];

    constructor() 
    {
            	                        this.chatRoomIdentifier = "" ;
                                this.messagesIdentifier = [];
                    }
}

export class TablePagedResultOfClubSubscription {
    data : ClubSubscription[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class ClubSubscription extends BaseEntity {
    number : string;
    user : NameIdentifier;
    startFrom : string ;
    expiresOn : string ;
    purchaseIdentifier : string;
    isInternalInstallment : boolean;
    isSinglePayment : boolean;
    installments : SubscriptionInstallment[];
    contracts : Attachment[];
    contractSignedOn : string ;
    generatedOtpForSigning : string;
    tierHistory : DateValueOfInteger[];

    constructor() 
    {
            	        super();
		                        this.number = "" ;
                                this.user = new NameIdentifier();
                                this.startFrom = null;
                                this.expiresOn = null;
                                this.purchaseIdentifier = "" ;
                                this.isInternalInstallment = false ;
                                this.isSinglePayment = false ;
                                this.installments = [];
                                this.contracts = [];
                                this.contractSignedOn = null;
                                this.generatedOtpForSigning = "" ;
                                this.tierHistory = [];
                    }
}

export class SubscriptionInstallment {
    number : string;
    amount : number;
    dueOn : string ;
    paidOn : string ;
    createsVoucher : boolean;

    constructor() 
    {
            	                        this.number = "" ;
                                this.amount = null ;
                                this.dueOn = null;
                                this.paidOn = null;
                                this.createsVoucher = false ;
                    }
}

export class DateValueOfInteger {
    date : string ;
    value : number;

    constructor() 
    {
            	                        this.date = null;
                                this.value = null ;
                    }
}

export class ClubSubscriptionListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    createdOnFrom : string ;
    createdOnTo : string ;
    number : string;
    startFromFrom : string ;
    startFromTo : string ;
    expiresOnFrom : string ;
    expiresOnTo : string ;
    isInternalInstallment : boolean;
    user : string;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.createdOnFrom = null;
                                this.createdOnTo = null;
                                this.number = "" ;
                                this.startFromFrom = null;
                                this.startFromTo = null;
                                this.expiresOnFrom = null;
                                this.expiresOnTo = null;
                                this.isInternalInstallment = false ;
                                this.user = "" ;
                    }
}

export class AddClubSubscriptionVm {
    userIdentifier : string;
    tier : number;
    days : number;
    vacationVouchersAmount : number;
    installmentConfig : MembershipInstallmentConfig;

    constructor() 
    {
            	                        this.userIdentifier = "" ;
                                this.tier = null ;
                                this.days = null ;
                                this.vacationVouchersAmount = null ;
                                this.installmentConfig = new MembershipInstallmentConfig();
                    }
}

export class MembershipInstallmentConfig {
    number : number;
    amount : number;
    createVacationVoucherOnNumbers : number[];

    constructor() 
    {
            	                        this.number = null ;
                                this.amount = null ;
                                this.createVacationVoucherOnNumbers = [];
                    }
}

export class TablePagedResultOfBaseCommission {
    data : BaseCommission[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class BaseCommission extends BaseEntity {
    type : string;
    originUser : NameIdentifier;
    user : NameIdentifier;
    upliner : NameIdentifier;
    userQualification : Qualification;
    uplinerQualification : Qualification;
    paidOn : string ;
    paidAmount : number;
    usedDifferentialPayment : boolean;

    constructor() 
    {
            	        super();
		                        this.type = "" ;
                                this.originUser = new NameIdentifier();
                                this.user = new NameIdentifier();
                                this.upliner = new NameIdentifier();
                                this.userQualification = new Qualification();
                                this.uplinerQualification = new Qualification();
                                this.paidOn = null;
                                this.paidAmount = null ;
                                this.usedDifferentialPayment = false ;
                    }
}

export class Qualification {
    date : string ;
    qualificationCode : string;

    constructor() 
    {
            	                        this.date = null;
                                this.qualificationCode = "" ;
                    }
}

export class ProvvigioniListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    createdOn : string ;
    createdFrom : string ;
    createdTo : string ;
    modifiedOn : string ;
    customer : string;
    user : string;
    rebateRowId : string;
    performanceRowId : string;
    parent : string;
    userQualification : string;
    parentQualification : string;
    points : number;
    paidAmount : number;
    showZeroLines : boolean;
    type : string;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.createdOn = null;
                                this.createdFrom = null;
                                this.createdTo = null;
                                this.modifiedOn = null;
                                this.customer = "" ;
                                this.user = "" ;
                                this.rebateRowId = "" ;
                                this.performanceRowId = "" ;
                                this.parent = "" ;
                                this.userQualification = "" ;
                                this.parentQualification = "" ;
                                this.points = null ;
                                this.paidAmount = null ;
                                this.showZeroLines = false ;
                                this.type = "" ;
                    }
}

export class DashboardPortafoglioVm {
    balance : number;
    waiting : number;
    withdrawed : number;
    total : number;

    constructor() 
    {
            	                        this.balance = null ;
                                this.waiting = null ;
                                this.withdrawed = null ;
                                this.total = null ;
                    }
}

export class ContatoreAttiviVm {
    total : number;
    actives : number;

    constructor() 
    {
            	                        this.total = null ;
                                this.actives = null ;
                    }
}

export class DashboardProfileVm {
    identifier : string;
    name : string;
    referralCode : string;
    image : Attachment;
    saldo : number;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.name = "" ;
                                this.referralCode = "" ;
                                this.image = new Attachment();
                                this.saldo = null ;
                    }
}

export class BaseWalletTransaction extends BaseEntity {
    user : NameIdentifier;
    date : string ;
    amount : number;
    currency : CurrencyData;
    note : string;
    type : string;

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.date = null;
                                this.amount = null ;
                                this.currency = new CurrencyData();
                                this.note = "" ;
                                this.type = "" ;
                    }
}

export class WalletUserWithdraw extends BaseWalletTransaction {
    receiptNumber : string;
    userPaymentRequestIdentifier : string;

    constructor() 
    {
            	        super();
		                        this.receiptNumber = "" ;
                                this.userPaymentRequestIdentifier = "" ;
                    }
}

export class CurrencyData {
    name : string;
    symbol : string;
    code : string;

    constructor() 
    {
            	                        this.name = "" ;
                                this.symbol = "" ;
                                this.code = "" ;
                    }
}

export class UserCardVm {
    identifier : string;
    image : Attachment;
    name : string;
    earned : number;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.image = new Attachment();
                                this.name = "" ;
                                this.earned = null ;
                    }
}

export class UserObiettivoCardVm {
    identifier : string;
    image : Attachment;
    name : string;
    obiettivo : number;
    risultato : number;
    fatturato : number;
    saldo : number;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.image = new Attachment();
                                this.name = "" ;
                                this.obiettivo = null ;
                                this.risultato = null ;
                                this.fatturato = null ;
                                this.saldo = null ;
                    }
}

export class DeferredPayment extends BaseEntity {
    amount : number;
    currencyCode : string;
    currencySymbol : string;
    customer : NameIdentifier;
    confirmedOn : string ;
    comments : Comment[];
    internalComments : Comment[];
    canceledOn : string ;
    method : string;
    type : string;

    constructor() 
    {
            	        super();
		                        this.amount = null ;
                                this.currencyCode = "" ;
                                this.currencySymbol = "" ;
                                this.customer = new NameIdentifier();
                                this.confirmedOn = null;
                                this.comments = [];
                                this.internalComments = [];
                                this.canceledOn = null;
                                this.method = "" ;
                                this.type = "" ;
                    }
}

export class CreateDeferredPaymentFromCartVm {
    method : string;
    cart : ShoppingCart;

    constructor() 
    {
            	                        this.method = "" ;
                                this.cart = new ShoppingCart();
                    }
}

export class ShoppingCart extends BaseEntity {
    customer : NameIdentifier;
    offers : OfferQuantityPair[];
    formAnswers : { [key: string]: string[]; };
    isPending : boolean;

    constructor() 
    {
            	        super();
		                        this.customer = new NameIdentifier();
                                this.offers = [];
                                this.formAnswers = {};
                                this.isPending = false ;
                    }
}

export class OfferQuantityPair {
    offer : NameIdentifier;
    quantity : number;

    constructor() 
    {
            	                        this.offer = new NameIdentifier();
                                this.quantity = null ;
                    }
}

export class CardTopUp extends DeferredPayment {
    cardNumber : string;

    constructor() 
    {
            	        super();
		                        this.cardNumber = "" ;
                    }
}

export class CreateCardTopUpVm {
    customer : NameIdentifier;
    cardNumber : string;
    amount : number;
    project : string;
    country : string;
    paymentMethod : string;

    constructor() 
    {
            	                        this.customer = new NameIdentifier();
                                this.cardNumber = "" ;
                                this.amount = null ;
                                this.project = "" ;
                                this.country = "" ;
                                this.paymentMethod = "" ;
                    }
}

export class TablePagedResultOfDeferredPayment {
    data : DeferredPayment[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class PagamentoBonificoListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    fromDate : string ;
    toDate : string ;
    customer : string;
    offers : string;
    amount : string;
    approvedFromDate : string ;
    approvedToDate : string ;
    documentoCaricato : boolean;
    canceled : boolean;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.fromDate = null;
                                this.toDate = null;
                                this.customer = "" ;
                                this.offers = "" ;
                                this.amount = "" ;
                                this.approvedFromDate = null;
                                this.approvedToDate = null;
                                this.documentoCaricato = false ;
                                this.canceled = false ;
                    }
}

export class FaqNode extends BaseEntity {
    isRoot : boolean;
    nodeText : LocalizedValue;
    answersList : FaqNodeText[];

    constructor() 
    {
            	        super();
		                        this.isRoot = false ;
                                this.nodeText = new LocalizedValue();
                                this.answersList = [];
                    }
}

export class LocalizedObjectOfString {
    values : { [key: string]: string; };

    constructor() 
    {
            	                        this.values = {};
                    }
}

export class LocalizedValue extends LocalizedObjectOfString {

    constructor() 
    {
            	        super();
		            }
}

export class FaqNodeText {
    identifier : string;
    name : LocalizedValue;
    order : number;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.name = new LocalizedValue();
                                this.order = null ;
                    }
}

export class InAppNotification extends BaseEntity {
    user : NameIdentifier;
    readOn : string ;
    text : string;
    type : string;

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.readOn = null;
                                this.text = "" ;
                                this.type = "" ;
                    }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
            	                        this.key = "" ;
                                this.value = "" ;
                    }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor() 
    {
            	        super();
		                        this.key = "" ;
                                this.identifier = "" ;
                    }
}

export class LoginData {
    userIdentifier : string;
    subscriptionActive : boolean;
    agentSubscriptionActive : boolean;
    token : string;

    constructor() 
    {
            	                        this.userIdentifier = "" ;
                                this.subscriptionActive = false ;
                                this.agentSubscriptionActive = false ;
                                this.token = "" ;
                    }
}

export class LoginVm {
    username : string;
    password : string;

    constructor() 
    {
            	                        this.username = "" ;
                                this.password = "" ;
                    }
}

export class RegisterVm {
    username : string;
    password : string;

    constructor() 
    {
            	                        this.username = "" ;
                                this.password = "" ;
                    }
}

export class OAuthSignInVm {
    idToken : string;
    villageIdentifier : string;
    preferredCulture : string;

    constructor() 
    {
            	                        this.idToken = "" ;
                                this.villageIdentifier = "" ;
                                this.preferredCulture = "" ;
                    }
}

export class AppleSignInVm extends OAuthSignInVm {
    name : string;
    surname : string;

    constructor() 
    {
            	        super();
		                        this.name = "" ;
                                this.surname = "" ;
                    }
}

export class MailEventDefinition {
    eventName : string;
    variables : string[];

    constructor() 
    {
            	                        this.eventName = "" ;
                                this.variables = [];
                    }
}

export class TablePagedResultOfMailSentLog {
    data : MailSentLog[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class MailSentLog extends BaseEntity {
    mailEvent : string;
    variables : string;
    recipients : string[];
    ccs : string[];
    bccs : string[];

    constructor() 
    {
            	        super();
		                        this.mailEvent = "" ;
                                this.variables = "" ;
                                this.recipients = [];
                                this.ccs = [];
                                this.bccs = [];
                    }
}

export class MailSentLogListFilterVm extends BasePagedRequest {
    createdOn : string ;
    mailEvent : string;
    variables : string;
    recipients : string;
    ccs : string;
    bccs : string;

    constructor() 
    {
            	        super();
		                        this.createdOn = null;
                                this.mailEvent = "" ;
                                this.variables = "" ;
                                this.recipients = "" ;
                                this.ccs = "" ;
                                this.bccs = "" ;
                    }
}

export class MessageOfTheDay extends BaseEntity {
    message : string;
    author : string;
    dayNumber : number;
    monthNumber : number;

    constructor() 
    {
            	        super();
		                        this.message = "" ;
                                this.author = "" ;
                                this.dayNumber = null ;
                                this.monthNumber = null ;
                    }
}

export class NetworkUserVm {
    createdOn : string ;
    completeName : string;
    image : Attachment;
    referralCode : string;
    role : string;
    type : string;
    telephone : string;
    qualification : Qualification;
    identifier : string;

    constructor() 
    {
            	                        this.createdOn = null;
                                this.completeName = "" ;
                                this.image = new Attachment();
                                this.referralCode = "" ;
                                this.role = "" ;
                                this.type = "" ;
                                this.telephone = "" ;
                                this.qualification = new Qualification();
                                this.identifier = "" ;
                    }
}

export class NewsFeedItem extends BaseEntity {
    publishedOn : string ;
    title : LocalizedValue;
    htmlText : LocalizedValue;
    backgroundImage : Attachment;
    backgroundColor : string;

    constructor() 
    {
            	        super();
		                        this.publishedOn = null;
                                this.title = new LocalizedValue();
                                this.htmlText = new LocalizedValue();
                                this.backgroundImage = new Attachment();
                                this.backgroundColor = "" ;
                    }
}

export class NewsFeedItemListVm {
    identifier : string;
    publishedOn : string ;
    title : string;
    excerpt : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.publishedOn = null;
                                this.title = "" ;
                                this.excerpt = "" ;
                    }
}

export class PhotoPrintRequest extends BaseEntity {
    photoGalleryIdentifier : string;
    attachment : Attachment;
    village : NameIdentifier;
    user : NameIdentifier;
    gestitaOn : string ;
    comments : Comment[];

    constructor() 
    {
            	        super();
		                        this.photoGalleryIdentifier = "" ;
                                this.attachment = new Attachment();
                                this.village = new NameIdentifier();
                                this.user = new NameIdentifier();
                                this.gestitaOn = null;
                                this.comments = [];
                    }
}

export class ProjectConfig extends BaseEntity {
    dashboardModules : string[];
    smtpMailConfig : SmtpMail;
    projectColors : ProjectColors;
    urlConfig : UrlConfig;
    skebbySmsSender : SkebbySmsSender;
    ticketTimeTable : TicketTimeTable;
    leadStatuses : string[];
    leadSubStatuses : string[];
    frontendModules : FrontendModuleConfig[];
    paymentRequestConfig : PaymentRequestConfig;
    scratchAndWinConfig : ScratchAndWinConfig;
    userRicezioneLead : NameIdentifier;
    paymentConfigDetails : PaymentConfigDetails;
    membershipLandingPage : MembershipLandingPage;
    auraCoinValueMultiplier : number;

    constructor() 
    {
            	        super();
		                        this.dashboardModules = [];
                                this.smtpMailConfig = new SmtpMail();
                                this.projectColors = new ProjectColors();
                                this.urlConfig = new UrlConfig();
                                this.skebbySmsSender = new SkebbySmsSender();
                                this.ticketTimeTable = new TicketTimeTable();
                                this.leadStatuses = [];
                                this.leadSubStatuses = [];
                                this.frontendModules = [];
                                this.paymentRequestConfig = new PaymentRequestConfig();
                                this.scratchAndWinConfig = new ScratchAndWinConfig();
                                this.userRicezioneLead = new NameIdentifier();
                                this.paymentConfigDetails = new PaymentConfigDetails();
                                this.membershipLandingPage = new MembershipLandingPage();
                                this.auraCoinValueMultiplier = null ;
                    }
}

export class SmtpMail {
    server : string;
    port : number;
    enableSsl : boolean;
    username : string;
    password : string;
    defaultSenderEmail : string;
    defaultSenderName : string;

    constructor() 
    {
            	                        this.server = "" ;
                                this.port = null ;
                                this.enableSsl = false ;
                                this.username = "" ;
                                this.password = "" ;
                                this.defaultSenderEmail = "" ;
                                this.defaultSenderName = "" ;
                    }
}

export class ProjectColors {
    primary : string;
    primaryContrast : string;
    primaryBorder : string;
    primaryHover : string;
    primaryHoverContrast : string;
    primaryHoverBorder : string;
    secondary : string;
    secondaryContrast : string;
    secondaryBorder : string;
    secondaryHover : string;
    secondaryHoverContrast : string;
    secondaryHoverBorder : string;
    background : string;
    backgroundSecondary : string;
    backgroundContent : string;
    textColor : string;
    textColorLink : string;

    constructor() 
    {
            	                        this.primary = "" ;
                                this.primaryContrast = "" ;
                                this.primaryBorder = "" ;
                                this.primaryHover = "" ;
                                this.primaryHoverContrast = "" ;
                                this.primaryHoverBorder = "" ;
                                this.secondary = "" ;
                                this.secondaryContrast = "" ;
                                this.secondaryBorder = "" ;
                                this.secondaryHover = "" ;
                                this.secondaryHoverContrast = "" ;
                                this.secondaryHoverBorder = "" ;
                                this.background = "" ;
                                this.backgroundSecondary = "" ;
                                this.backgroundContent = "" ;
                                this.textColor = "" ;
                                this.textColorLink = "" ;
                    }
}

export class UrlConfig {
    playStoreUrl : string;
    appStoreUrl : string;
    appGalleryUrl : string;
    apiUrl : string;
    websocketUrl : string;
    webAppUrl : string;
    backofficeUrl : string;
    siteUrl : string;
    privacyUrl : string;
    regolamentoUrl : string;

    constructor() 
    {
            	                        this.playStoreUrl = "" ;
                                this.appStoreUrl = "" ;
                                this.appGalleryUrl = "" ;
                                this.apiUrl = "" ;
                                this.websocketUrl = "" ;
                                this.webAppUrl = "" ;
                                this.backofficeUrl = "" ;
                                this.siteUrl = "" ;
                                this.privacyUrl = "" ;
                                this.regolamentoUrl = "" ;
                    }
}

export class SkebbySmsSender {
    username : string;
    password : string;
    sender : string;

    constructor() 
    {
            	                        this.username = "" ;
                                this.password = "" ;
                                this.sender = "" ;
                    }
}

export class TicketTimeTable {
    userAssigned : NameIdentifier;
    firstMessageAfterTicket : LocalizedValue;
    textWhenClosed : LocalizedValue;
    times : TicketTimeTableTimes[];

    constructor() 
    {
            	                        this.userAssigned = new NameIdentifier();
                                this.firstMessageAfterTicket = new LocalizedValue();
                                this.textWhenClosed = new LocalizedValue();
                                this.times = [];
                    }
}

export class TicketTimeTableTimes {
    day : DayOfWeek;
    startTime : string;
    endTime : string;

    constructor() 
    {
            	                        this.day = null;
                                this.startTime = "" ;
                                this.endTime = "" ;
                    }
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class FrontendModuleConfig {
    name : string;
    order : number;
    isCustom : boolean;
    customName : string;
    customUrl : string;
    isTargetBlank : boolean;

    constructor() 
    {
            	                        this.name = "" ;
                                this.order = null ;
                                this.isCustom = false ;
                                this.customName = "" ;
                                this.customUrl = "" ;
                                this.isTargetBlank = false ;
                    }
}

export class PaymentRequestConfig {
    lastPossibleDayOfTheMonth : number;
    minimumPayment : number;
    ritenutaPercentage : number;
    paymentRequestMethods : PaymentRequestMethodDetails[];

    constructor() 
    {
            	                        this.lastPossibleDayOfTheMonth = null ;
                                this.minimumPayment = null ;
                                this.ritenutaPercentage = null ;
                                this.paymentRequestMethods = [];
                    }
}

export class PaymentRequestMethodDetails {
    name : string;
    methodType : string;

    constructor() 
    {
            	                        this.name = "" ;
                                this.methodType = "" ;
                    }
}

export class ScratchAndWinConfig {
    rulesHtmlText : LocalizedValue;
    shortRulesHtmlText : LocalizedValue;

    constructor() 
    {
            	                        this.rulesHtmlText = new LocalizedValue();
                                this.shortRulesHtmlText = new LocalizedValue();
                    }
}

export class PaymentConfigDetails {
    paymentMethodsAllowed : PaymentMethodDetails[];
    bonificoConfigDetails : BonificoConfigDetails;
    stripeConfigDetails : StripeConfigDetails;
    receiptCode : string;
    currencyCode : string;
    currencySymbol : string;
    receiptFooter : string;
    needsFiscalCode : boolean;

    constructor() 
    {
            	                        this.paymentMethodsAllowed = [];
                                this.bonificoConfigDetails = new BonificoConfigDetails();
                                this.stripeConfigDetails = new StripeConfigDetails();
                                this.receiptCode = "" ;
                                this.currencyCode = "" ;
                                this.currencySymbol = "" ;
                                this.receiptFooter = "" ;
                                this.needsFiscalCode = false ;
                    }
}

export class PaymentMethodDetails {
    name : string;
    title : LocalizedValue;
    description : LocalizedValue;
    methodType : string;
    useComments : boolean;
    priceMultiplier : number;
    currencySymbol : string;

    constructor() 
    {
            	                        this.name = "" ;
                                this.title = new LocalizedValue();
                                this.description = new LocalizedValue();
                                this.methodType = "" ;
                                this.useComments = false ;
                                this.priceMultiplier = null ;
                                this.currencySymbol = "" ;
                    }
}

export class BonificoConfigDetails {
    bankDetails : string;

    constructor() 
    {
            	                        this.bankDetails = "" ;
                    }
}

export class StripeConfigDetails {
    stripePublicKey : string;
    stripeSecretKey : string;
    webhookSecret : string;
    paymentSuccessUrl : string;

    constructor() 
    {
            	                        this.stripePublicKey = "" ;
                                this.stripeSecretKey = "" ;
                                this.webhookSecret = "" ;
                                this.paymentSuccessUrl = "" ;
                    }
}

export class MembershipLandingPage {
    htmlBlocks : LocalizedObjectOfListOfBaseHtmlBlock;

    constructor() 
    {
            	                        this.htmlBlocks = new LocalizedObjectOfListOfBaseHtmlBlock();
                    }
}

export class LocalizedObjectOfListOfBaseHtmlBlock {
    values : { [key: string]: BaseHtmlBlock[]; };

    constructor() 
    {
            	                        this.values = {};
                    }
}

export abstract class BaseHtmlBlock {
    name : string;
    htmlText : string;
    isFullWidth : boolean;
    marginBottom : number;
    type : string;

    constructor() 
    {
            	                        this.name = "" ;
                                this.htmlText = "" ;
                                this.isFullWidth = false ;
                                this.marginBottom = null ;
                                this.type = "" ;
                    }
}

export class ProjectConfigVm {
    name : string;
    siteUrl : string;
    modules : FrontendModuleConfig[];
    dashboardModules : string[];
    colors : ProjectColors;

    constructor() 
    {
            	                        this.name = "" ;
                                this.siteUrl = "" ;
                                this.modules = [];
                                this.dashboardModules = [];
                                this.colors = new ProjectColors();
                    }
}

export class PaymentConfigVm {
    stripePublicKey : string;
    currencySymbol : string;

    constructor() 
    {
            	                        this.stripePublicKey = "" ;
                                this.currencySymbol = "" ;
                    }
}

export class CanRequestPaymentVm {
    paymentRequestConfig : PaymentRequestConfig;
    canRequest : boolean;

    constructor() 
    {
            	                        this.paymentRequestConfig = new PaymentRequestConfig();
                                this.canRequest = false ;
                    }
}

export class GetOrariAperturaTicketVm {
    text : LocalizedValue;
    canOpen : boolean;

    constructor() 
    {
            	                        this.text = new LocalizedValue();
                                this.canOpen = false ;
                    }
}

export class PrefixCountry {
    country : string;
    prefix : string;

    constructor() 
    {
            	                        this.country = "" ;
                                this.prefix = "" ;
                    }
}

export class SwaggerModelFiller {
    baseHtmlBlock : BaseHtmlBlock;
    htmlTextBlock : HtmlTextBlock;
    bluePaintBlock : BluePaintBlock;
    bulletPointsBlock : BulletPointsBlock;
    midTitleBlock : MidTitleBlock;
    paragraphBlock : ParagraphBlock;
    priceBlock : PriceBlock;
    routerButtonBlock : RouterButtonBlock;
    titleBlock : TitleBlock;
    trapezioBlock : TrapezioBlock;
    shopProductsClubVacationVoucherProduct : ClubVacationVoucherProduct;
    shopProductsAuracoinTopUpProduct : AuracoinTopUpProduct;
    shopProductsUpgradeMembershipProduct : UpgradeMembershipProduct;
    shopProductsBookingVoucherProduct : MembershipProduct;
    shopProductsCardProduct : CardProduct;
    shopProductsPhysical : PhysicalProduct;
    shopProductGalleryItemCreditsProduct : GalleryItemCreditsProduct;
    purchaseDeferredPayment : PurchaseDeferredPayment;
    cardTopUp : CardTopUp;
    wallesterKeysConfig : WallesterKeysConfig;
    walletMoneyTransfer : WalletMoneyTransfer;
    backofficeCustom : BackofficeCustom;
    clubSubscriptionConfirmed : ClubSubscriptionConfirmed;
    clubVacationBookingAnswer : ClubVacationBookingAnswer;
    moneyTransferReceived : MoneyTransferReceived;
    monthlyCommissionsPaid : MonthlyCommissionsPaid;
    newChatMessage : NewChatMessage;
    newRegistrationWithYourCode : NewRegistrationWithYourCode;
    villageTripBookAnswer : VillageTripBookAnswer;
    backendNotificationNewChatMessage : BackendNotificationNewChatMessage;
    backendNotificationVillageTripBooked : BackendNotificationVillageTripBooked;

    constructor() 
    {
        
            }
}

export class HtmlTextBlock extends BaseHtmlBlock {
    text : string;

    constructor() 
    {
            	        super();
		                        this.text = "" ;
                    }
}

export class BluePaintBlock extends BaseHtmlBlock {
    topButtonHref : string;
    topButtonText : string;
    text : string;

    constructor() 
    {
            	        super();
		                        this.topButtonHref = "" ;
                                this.topButtonText = "" ;
                                this.text = "" ;
                    }
}

export class BulletPointsBlock extends BaseHtmlBlock {
    useChecks : boolean;
    points : string[];

    constructor() 
    {
            	        super();
		                        this.useChecks = false ;
                                this.points = [];
                    }
}

export class MidTitleBlock extends BaseHtmlBlock {
    text : string;

    constructor() 
    {
            	        super();
		                        this.text = "" ;
                    }
}

export class ParagraphBlock extends BaseHtmlBlock {
    text : string;

    constructor() 
    {
            	        super();
		                        this.text = "" ;
                    }
}

export class PriceBlock extends BaseHtmlBlock {
    fullPrice : string;
    finalPrice : string;
    currency : string;
    note : string;

    constructor() 
    {
            	        super();
		                        this.fullPrice = "" ;
                                this.finalPrice = "" ;
                                this.currency = "" ;
                                this.note = "" ;
                    }
}

export class RouterButtonBlock extends BaseHtmlBlock {
    text : string;
    href : string;

    constructor() 
    {
            	        super();
		                        this.text = "" ;
                                this.href = "" ;
                    }
}

export class TitleBlock extends BaseHtmlBlock {
    text : string;

    constructor() 
    {
            	        super();
		                        this.text = "" ;
                    }
}

export class TrapezioBlock extends BaseHtmlBlock {
    text : string;

    constructor() 
    {
            	        super();
		                        this.text = "" ;
                    }
}

export class BaseProduct extends BaseEntity {
    name : string;
    title : LocalizedValue;
    subTitle : LocalizedValue;
    type : string;
    displayOrder : number;

    constructor() 
    {
            	        super();
		                        this.name = "" ;
                                this.title = new LocalizedValue();
                                this.subTitle = new LocalizedValue();
                                this.type = "" ;
                                this.displayOrder = null ;
                    }
}

export class ClubVacationVoucherProduct extends BaseProduct {
    vacationVouchers : number;

    constructor() 
    {
            	        super();
		                        this.vacationVouchers = null ;
                    }
}

export class AuracoinTopUpProduct extends BaseProduct {

    constructor() 
    {
            	        super();
		            }
}

export class UpgradeMembershipProduct extends BaseProduct {
    upgradeToTier : number;
    daysToAdd : number;
    vacationVouchers : number;

    constructor() 
    {
            	        super();
		                        this.upgradeToTier = null ;
                                this.daysToAdd = null ;
                                this.vacationVouchers = null ;
                    }
}

export class MembershipProduct extends BaseProduct {
    tier : number;
    daysToAdd : number;
    vacationVouchers : number;
    installmentConfig : MembershipInstallmentConfig;

    constructor() 
    {
            	        super();
		                        this.tier = null ;
                                this.daysToAdd = null ;
                                this.vacationVouchers = null ;
                                this.installmentConfig = new MembershipInstallmentConfig();
                    }
}

export class CardProduct extends BaseProduct {

    constructor() 
    {
            	        super();
		            }
}

export class PhysicalProduct extends BaseProduct {

    constructor() 
    {
            	        super();
		            }
}

export class GalleryItemCreditsProduct extends BaseProduct {
    amountOfCredits : number;

    constructor() 
    {
            	        super();
		                        this.amountOfCredits = null ;
                    }
}

export class PurchaseDeferredPayment extends DeferredPayment {
    savedShoppingCart : ShoppingCart;

    constructor() 
    {
            	        super();
		                        this.savedShoppingCart = new ShoppingCart();
                    }
}

export class WallesterKeysConfig extends BaseEntity {
    projectConfigIdentifier : string;
    apiKey : string;
    publicKeyPath : string;
    privateKeyPath : string;

    constructor() 
    {
            	        super();
		                        this.projectConfigIdentifier = "" ;
                                this.apiKey = "" ;
                                this.publicKeyPath = "" ;
                                this.privateKeyPath = "" ;
                    }
}

export class WalletMoneyTransfer extends BaseWalletTransaction {
    sentTo : NameIdentifier;
    receivedFrom : NameIdentifier;

    constructor() 
    {
            	        super();
		                        this.sentTo = new NameIdentifier();
                                this.receivedFrom = new NameIdentifier();
                    }
}

export class BackofficeCustom extends InAppNotification {
    icon : string;
    navigationPath : string;

    constructor() 
    {
            	        super();
		                        this.icon = "" ;
                                this.navigationPath = "" ;
                    }
}

export class ClubSubscriptionConfirmed extends InAppNotification {

    constructor() 
    {
            	        super();
		            }
}

export class ClubVacationBookingAnswer extends InAppNotification {
    village : NameIdentifier;
    clubVacationBookingIdentifier : string;
    bookingFromDate : string ;
    bookingToDate : string ;
    bookingNumber : string;
    status : string;

    constructor() 
    {
            	        super();
		                        this.village = new NameIdentifier();
                                this.clubVacationBookingIdentifier = "" ;
                                this.bookingFromDate = null;
                                this.bookingToDate = null;
                                this.bookingNumber = "" ;
                                this.status = "" ;
                    }
}

export class MoneyTransferReceived extends InAppNotification {

    constructor() 
    {
            	        super();
		            }
}

export class MonthlyCommissionsPaid extends InAppNotification {

    constructor() 
    {
            	        super();
		            }
}

export class NewChatMessage extends InAppNotification {
    chatIdentifier : string;
    villageIdentifier : string;

    constructor() 
    {
            	        super();
		                        this.chatIdentifier = "" ;
                                this.villageIdentifier = "" ;
                    }
}

export class NewRegistrationWithYourCode extends InAppNotification {

    constructor() 
    {
            	        super();
		            }
}

export class VillageTripBookAnswer extends InAppNotification {
    villageTrip : NameIdentifier;
    status : string;

    constructor() 
    {
            	        super();
		                        this.villageTrip = new NameIdentifier();
                                this.status = "" ;
                    }
}

export class BackendNotificationNewChatMessage extends BaseBackendNotification {
    author : NameIdentifier;
    chatIdentifier : string;

    constructor() 
    {
            	        super();
		                        this.author = new NameIdentifier();
                                this.chatIdentifier = "" ;
                    }
}

export class BackendNotificationVillageTripBooked extends BaseBackendNotification {
    customer : NameIdentifier;
    villageTrip : NameIdentifier;

    constructor() 
    {
            	        super();
		                        this.customer = new NameIdentifier();
                                this.villageTrip = new NameIdentifier();
                    }
}

export class Purchase extends BaseEntity {
    customer : NameIdentifier;
    networkNode : NameIdentifier;
    purchasedOffers : PurchasedOffer[];
    paidAmount : number;
    paidCurrencySymbol : string;
    trackingNumber : string;
    number : string;
    shippingAddress : Address;
    fiscalData : FiscalData;
    status : string;
    statusHistory : DateValueOfString[];
    shippingCost : number;
    hiddenToCustomer : boolean;
    paymentType : string;
    formAnswers : { [key: string]: string[]; };
    stripePaymentIntentId : string;
    totalGrossAmount : number;
    totalPoints : number;

    constructor() 
    {
            	        super();
		                        this.customer = new NameIdentifier();
                                this.networkNode = new NameIdentifier();
                                this.purchasedOffers = [];
                                this.paidAmount = null ;
                                this.paidCurrencySymbol = "" ;
                                this.trackingNumber = "" ;
                                this.number = "" ;
                                this.shippingAddress = new Address();
                                this.fiscalData = new FiscalData();
                                this.status = "" ;
                                this.statusHistory = [];
                                this.shippingCost = null ;
                                this.hiddenToCustomer = false ;
                                this.paymentType = "" ;
                                this.formAnswers = {};
                                this.stripePaymentIntentId = "" ;
                                this.totalGrossAmount = null ;
                                this.totalPoints = null ;
                    }
}

export class PurchasedOffer {
    identifier : string;
    image : Attachment;
    name : string;
    displayName : LocalizedValue;
    subTitle : LocalizedValue;
    priceEntry : PriceConfig;
    rewardConfig : RewardConfig;
    quantity : number;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.image = new Attachment();
                                this.name = "" ;
                                this.displayName = new LocalizedValue();
                                this.subTitle = new LocalizedValue();
                                this.priceEntry = new PriceConfig();
                                this.rewardConfig = new RewardConfig();
                                this.quantity = null ;
                    }
}

export class PriceConfig {
    grossAmount : number;
    vatPerc : number;
    symbol : string;

    constructor() 
    {
            	                        this.grossAmount = null ;
                                this.vatPerc = null ;
                                this.symbol = "" ;
                    }
}

export class RewardConfig {
    points : number;
    bonusPayments : BonusPaymentLevel[];

    constructor() 
    {
            	                        this.points = null ;
                                this.bonusPayments = [];
                    }
}

export class BonusPaymentLevel {
    level : number;
    paymentAmount : number;

    constructor() 
    {
            	                        this.level = null ;
                                this.paymentAmount = null ;
                    }
}

export class Address {
    typedAddress : string;
    citta : string;
    provincia : string;
    cap : string;
    scalaPianoInterno : string;
    via : string;
    civico : string;
    note : string;
    nazione : string;
    regione : string;
    latLong : LatLong;
    isEmpty : boolean;
    completeAddress : string;

    constructor() 
    {
            	                        this.typedAddress = "" ;
                                this.citta = "" ;
                                this.provincia = "" ;
                                this.cap = "" ;
                                this.scalaPianoInterno = "" ;
                                this.via = "" ;
                                this.civico = "" ;
                                this.note = "" ;
                                this.nazione = "" ;
                                this.regione = "" ;
                                this.latLong = new LatLong();
                                this.isEmpty = false ;
                                this.completeAddress = "" ;
                    }
}

export class LatLong {
    lat : number;
    long : number;

    constructor() 
    {
            	                        this.lat = null ;
                                this.long = null ;
                    }
}

export class FiscalData {
    name : string;
    surname : string;
    sex : string;
    birthDate : string ;
    birthPlace : string;
    fiscalCode : string;
    hasVat : boolean;
    companyName : string;
    vatNumber : string;
    codiceDestinatario : string;
    pec : string;
    fiscalAddress : Address;

    constructor() 
    {
            	                        this.name = "" ;
                                this.surname = "" ;
                                this.sex = "" ;
                                this.birthDate = null;
                                this.birthPlace = "" ;
                                this.fiscalCode = "" ;
                                this.hasVat = false ;
                                this.companyName = "" ;
                                this.vatNumber = "" ;
                                this.codiceDestinatario = "" ;
                                this.pec = "" ;
                                this.fiscalAddress = new Address();
                    }
}

export class DateValueOfString {
    date : string ;
    value : string;

    constructor() 
    {
            	                        this.date = null;
                                this.value = "" ;
                    }
}

export class MakePurchaseManuallyVm {
    hiddenToCustomer : boolean;
    cart : ShoppingCart;

    constructor() 
    {
            	                        this.hiddenToCustomer = false ;
                                this.cart = new ShoppingCart();
                    }
}

export class TablePagedResultOfPurchase {
    data : Purchase[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class PurchaseListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    fromDate : string ;
    toDate : string ;
    country : string;
    project : string;
    customer : string;
    networkNode : string;
    offers : string;
    totalGrossAmount : number;
    trackingNumber : string;
    number : string;
    shippingAddress : string;
    status : string;
    hiddenToCustomer : boolean;
    paymentType : string;
    points : string;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.fromDate = null;
                                this.toDate = null;
                                this.country = "" ;
                                this.project = "" ;
                                this.customer = "" ;
                                this.networkNode = "" ;
                                this.offers = "" ;
                                this.totalGrossAmount = null ;
                                this.trackingNumber = "" ;
                                this.number = "" ;
                                this.shippingAddress = "" ;
                                this.status = "" ;
                                this.hiddenToCustomer = false ;
                                this.paymentType = "" ;
                                this.points = "" ;
                    }
}

export class SendPushToListVm {
    userIds : string[];
    title : string;
    body : string;

    constructor() 
    {
            	                        this.userIds = [];
                                this.title = "" ;
                                this.body = "" ;
                    }
}

export class QualificationConfig extends BaseEntity {
    qualificationCode : string;
    order : number;
    manual : boolean;
    isBaseQualification : boolean;
    group : number;
    percentagesOnSubscriptions : CommissionRuleConfig;
    percentagesOnShopPurchases : CommissionRuleConfig;
    firstLineRequirements : QualificationConfigFirstLineRequirement[];
    networkTotalRequired : number;

    constructor() 
    {
            	        super();
		                        this.qualificationCode = "" ;
                                this.order = null ;
                                this.manual = false ;
                                this.isBaseQualification = false ;
                                this.group = null ;
                                this.percentagesOnSubscriptions = new CommissionRuleConfig();
                                this.percentagesOnShopPurchases = new CommissionRuleConfig();
                                this.firstLineRequirements = [];
                                this.networkTotalRequired = null ;
                    }
}

export class CommissionRuleConfig extends BaseEntity {
    payWithDifferential : boolean;
    percentageForDifferential : number;
    percentagePerLevel : number[];

    constructor() 
    {
            	        super();
		                        this.payWithDifferential = false ;
                                this.percentageForDifferential = null ;
                                this.percentagePerLevel = [];
                    }
}

export class QualificationConfigFirstLineRequirement {
    quantity : number;
    qualificationCode : string;

    constructor() 
    {
            	                        this.quantity = null ;
                                this.qualificationCode = "" ;
                    }
}

export class SmsEventDefinition {
    eventName : string;
    variables : string[];

    constructor() 
    {
            	                        this.eventName = "" ;
                                this.variables = [];
                    }
}

export class TablePagedResultOfSmsSentLog {
    data : SmsSentLog[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class SmsSentLog extends BaseEntity {
    eventName : string;
    recipient : string;
    variables : { [key: string]: any; };

    constructor() 
    {
            	        super();
		                        this.eventName = "" ;
                                this.recipient = "" ;
                                this.variables = {};
                    }
}

export class SmsSentLogListFilterVm extends BasePagedRequest {
    createdOn : string ;
    recipient : string;
    eventName : string;

    constructor() 
    {
            	        super();
		                        this.createdOn = null;
                                this.recipient = "" ;
                                this.eventName = "" ;
                    }
}

export class StripeClientPaymentConfig {
    merchantDisplayName : string;
    publishableKey : string;
    customerId : string;
    paymentIntentId : string;
    clientSecret : string;
    ephemeralKey : string;

    constructor() 
    {
            	                        this.merchantDisplayName = "" ;
                                this.publishableKey = "" ;
                                this.customerId = "" ;
                                this.paymentIntentId = "" ;
                                this.clientSecret = "" ;
                                this.ephemeralKey = "" ;
                    }
}

export class SurveyAnswers extends BaseEntity {
    survey : NameIdentifier;
    customer : NameIdentifier;
    answerValues : AnswerValue[];
    isCompleted : boolean;
    profession : NameIdentifier;
    doctor : NameIdentifier;
    surveyType : string;

    constructor() 
    {
            	        super();
		                        this.survey = new NameIdentifier();
                                this.customer = new NameIdentifier();
                                this.answerValues = [];
                                this.isCompleted = false ;
                                this.profession = new NameIdentifier();
                                this.doctor = new NameIdentifier();
                                this.surveyType = "" ;
                    }
}

export class AnswerValue {
    questionText : LocalizedValue;
    questionIdentifier : string;
    selectAnswer : LocalizedValue[];
    textAnswer : string;
    answerIndexes : number[];

    constructor() 
    {
            	                        this.questionText = new LocalizedValue();
                                this.questionIdentifier = "" ;
                                this.selectAnswer = [];
                                this.textAnswer = "" ;
                                this.answerIndexes = [];
                    }
}

export class Survey extends BaseEntity {
    isActive : boolean;
    name : string;
    questions : QuestionConfig[];
    profession : NameIdentifier;
    doctor : NameIdentifier;
    surveyType : string;

    constructor() 
    {
            	        super();
		                        this.isActive = false ;
                                this.name = "" ;
                                this.questions = [];
                                this.profession = new NameIdentifier();
                                this.doctor = new NameIdentifier();
                                this.surveyType = "" ;
                    }
}

export class QuestionConfig {
    identifier : string;
    text : LocalizedValue;
    required : boolean;
    isSingleSelect : boolean;
    isMultipleSelect : boolean;
    options : LocalizedValue[];
    hasParentQuestion : boolean;
    parentQuestionConfig : ParentQuestionConfig;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.text = new LocalizedValue();
                                this.required = false ;
                                this.isSingleSelect = false ;
                                this.isMultipleSelect = false ;
                                this.options = [];
                                this.hasParentQuestion = false ;
                                this.parentQuestionConfig = new ParentQuestionConfig();
                    }
}

export class ParentQuestionConfig {
    parentQuestionIdentifier : string;
    parentQuestionIndex : number;
    parentAnswerIndex : number;

    constructor() 
    {
            	                        this.parentQuestionIdentifier = "" ;
                                this.parentQuestionIndex = null ;
                                this.parentAnswerIndex = null ;
                    }
}

export class SurveyListVm {
    identifier : string;
    doctor : NameIdentifier;
    profession : NameIdentifier;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.doctor = new NameIdentifier();
                                this.profession = new NameIdentifier();
                    }
}

export class UserPaymentRequest extends BaseEntity {
    user : NameIdentifier;
    requestNumber : string;
    amount : number;
    date : string ;
    allegato : Attachment;
    useRitenutaAcconto : boolean;
    datiRitenutaAcconto : DatiRitenutaAcconto;
    gestitaOn : string ;
    walletTransactionIdentifier : string;
    paymentData : UserPaymentData;
    personalData : PersonalData;
    fiscalData : FiscalData;
    contactData : ContactData;

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.requestNumber = "" ;
                                this.amount = null ;
                                this.date = null;
                                this.allegato = new Attachment();
                                this.useRitenutaAcconto = false ;
                                this.datiRitenutaAcconto = new DatiRitenutaAcconto();
                                this.gestitaOn = null;
                                this.walletTransactionIdentifier = "" ;
                                this.paymentData = new UserPaymentData();
                                this.personalData = new PersonalData();
                                this.fiscalData = new FiscalData();
                                this.contactData = new ContactData();
                    }
}

export class DatiRitenutaAcconto {
    dataRitenuta : string;
    nomeUtente : string;
    luogoNascita : string;
    indirizzoResidenza : string;
    fiscalCode : string;
    iban : string;
    intestatarioConto : string;
    importoLordo : string;
    importoRitenuta : string;
    importoNetto : string;

    constructor() 
    {
            	                        this.dataRitenuta = "" ;
                                this.nomeUtente = "" ;
                                this.luogoNascita = "" ;
                                this.indirizzoResidenza = "" ;
                                this.fiscalCode = "" ;
                                this.iban = "" ;
                                this.intestatarioConto = "" ;
                                this.importoLordo = "" ;
                                this.importoRitenuta = "" ;
                                this.importoNetto = "" ;
                    }
}

export class UserPaymentData {
    bankAccountData : BankAccountData;
    paypalEmail : string;
    revolutNumber : string;
    modalitaPagamento : string;
    cryptoAddress : string;

    constructor() 
    {
            	                        this.bankAccountData = new BankAccountData();
                                this.paypalEmail = "" ;
                                this.revolutNumber = "" ;
                                this.modalitaPagamento = "" ;
                                this.cryptoAddress = "" ;
                    }
}

export class BankAccountData {
    holder : string;
    bankName : string;
    iban : string;
    swift : string;

    constructor() 
    {
            	                        this.holder = "" ;
                                this.bankName = "" ;
                                this.iban = "" ;
                                this.swift = "" ;
                    }
}

export class PersonalData {
    name : string;
    surname : string;
    profilePicture : Attachment;
    country : string;
    completeName : string;

    constructor() 
    {
            	                        this.name = "" ;
                                this.surname = "" ;
                                this.profilePicture = new Attachment();
                                this.country = "" ;
                                this.completeName = "" ;
                    }
}

export class ContactData {
    contactName : string;
    email : string;
    telephone : Telephone;
    address : Address;

    constructor() 
    {
            	                        this.contactName = "" ;
                                this.email = "" ;
                                this.telephone = new Telephone();
                                this.address = new Address();
                    }
}

export class Telephone {
    prefix : string;
    number : string;
    completeNumber : string;

    constructor() 
    {
            	                        this.prefix = "" ;
                                this.number = "" ;
                                this.completeNumber = "" ;
                    }
}

export class ConfirmUserPaymentRequestVm {
    userPaymentRequestIdentifier : string;
    note : string;

    constructor() 
    {
            	                        this.userPaymentRequestIdentifier = "" ;
                                this.note = "" ;
                    }
}

export class TablePagedResultOfClubVacationVoucher {
    data : ClubVacationVoucher[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class ClubVacationVoucher extends BaseEntity {
    user : NameIdentifier;
    subscription : NameIdentifier;
    purchaseIdentifier : string;
    usedOn : string ;
    clubVacationBookingIdentifier : string;
    parkedVacationIdentifier : string;
    comments : Comment[];

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.subscription = new NameIdentifier();
                                this.purchaseIdentifier = "" ;
                                this.usedOn = null;
                                this.clubVacationBookingIdentifier = "" ;
                                this.parkedVacationIdentifier = "" ;
                                this.comments = [];
                    }
}

export class ClubVacationVoucherListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    createdOnFrom : string ;
    createdOnTo : string ;
    usedOnFrom : string ;
    usedOnTo : string ;
    hasPurchase : boolean;
    hasBooking : boolean;
    hasParking : boolean;
    user : string;
    subscription : string;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.createdOnFrom = null;
                                this.createdOnTo = null;
                                this.usedOnFrom = null;
                                this.usedOnTo = null;
                                this.hasPurchase = false ;
                                this.hasBooking = false ;
                                this.hasParking = false ;
                                this.user = "" ;
                                this.subscription = "" ;
                    }
}

export class TablePagedResultOfParkedVacation {
    data : ParkedVacation[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class ParkedVacation extends BaseEntity {
    user : NameIdentifier;
    parkingCode : string;
    notes : string;
    resolvedOn : string ;

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.parkingCode = "" ;
                                this.notes = "" ;
                                this.resolvedOn = null;
                    }
}

export class ParkedVacationListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    createdOnFrom : string ;
    createdOnTo : string ;
    user : string;
    parkingCode : string;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.createdOnFrom = null;
                                this.createdOnTo = null;
                                this.user = "" ;
                                this.parkingCode = "" ;
                    }
}

export class VideoReview extends BaseEntity {
    user : NameIdentifier;
    village : NameIdentifier;
    attachment : Attachment;
    approvedOn : string ;

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.village = new NameIdentifier();
                                this.attachment = new Attachment();
                                this.approvedOn = null;
                    }
}

export class VillageGlobalGalleryItem extends BaseEntity {
    attachment : Attachment;
    original : Attachment;
    village : NameIdentifier;
    isVideo : boolean;
    publishedOn : string ;
    title : LocalizedValue;
    description : LocalizedValue;

    constructor() 
    {
            	        super();
		                        this.attachment = new Attachment();
                                this.original = new Attachment();
                                this.village = new NameIdentifier();
                                this.isVideo = false ;
                                this.publishedOn = null;
                                this.title = new LocalizedValue();
                                this.description = new LocalizedValue();
                    }
}

export class MoveVideoReviewToGalleryVm {
    videoReviewIdentifier : string;
    title : LocalizedValue;
    description : LocalizedValue;
    publishedOn : string ;

    constructor() 
    {
            	                        this.videoReviewIdentifier = "" ;
                                this.title = new LocalizedValue();
                                this.description = new LocalizedValue();
                                this.publishedOn = null;
                    }
}

export class VillageEvent extends BaseEntity {
    image : Attachment;
    village : NameIdentifier;
    icon : string;
    title : LocalizedValue;
    caption : LocalizedValue;
    htmlDescription : LocalizedValue;
    eventGroup : string;
    isRecurring : boolean;
    recurringFrom : string ;
    recurringTo : string ;
    recurringDays : DayOfWeek[];
    startTime : string;
    endTime : string;
    startDateTime : string ;
    endDateTime : string ;
    isHighlighted : boolean;

    constructor() 
    {
            	        super();
		                        this.image = new Attachment();
                                this.village = new NameIdentifier();
                                this.icon = "" ;
                                this.title = new LocalizedValue();
                                this.caption = new LocalizedValue();
                                this.htmlDescription = new LocalizedValue();
                                this.eventGroup = "" ;
                                this.isRecurring = false ;
                                this.recurringFrom = null;
                                this.recurringTo = null;
                                this.recurringDays = [];
                                this.startTime = "" ;
                                this.endTime = "" ;
                                this.startDateTime = null;
                                this.endDateTime = null;
                                this.isHighlighted = false ;
                    }
}

export class VillageTripBooking extends BaseEntity {
    village : NameIdentifier;
    trip : NameIdentifier;
    user : NameIdentifier;
    status : string;
    adults : number;
    infants : number;
    finalPrice : number;
    notes : string;
    date : string;

    constructor() 
    {
            	        super();
		                        this.village = new NameIdentifier();
                                this.trip = new NameIdentifier();
                                this.user = new NameIdentifier();
                                this.status = "" ;
                                this.adults = null ;
                                this.infants = null ;
                                this.finalPrice = null ;
                                this.notes = "" ;
                                this.date = "" ;
                    }
}

export class BookExcursionVm {
    userIdentifier : string;
    villageIdentifier : string;
    villageTripIdentifier : string;
    date : string;
    adults : number;
    infants : number;
    notes : string;

    constructor() 
    {
            	                        this.userIdentifier = "" ;
                                this.villageIdentifier = "" ;
                                this.villageTripIdentifier = "" ;
                                this.date = "" ;
                                this.adults = null ;
                                this.infants = null ;
                                this.notes = "" ;
                    }
}

export class VillageTripBookingActionVm {
    message : string;
    bookingIdentifier : string;
    sendMail : boolean;
    mailMessage : string;

    constructor() 
    {
            	                        this.message = "" ;
                                this.bookingIdentifier = "" ;
                                this.sendMail = false ;
                                this.mailMessage = "" ;
                    }
}

export class VillageTrip extends BaseEntity {
    name : string;
    image : Attachment;
    roundIcon : Attachment;
    village : NameIdentifier;
    title : LocalizedValue;
    caption : LocalizedValue;
    htmlDescription : LocalizedValue;
    emailInstructions : LocalizedValue;
    gallery : Attachment[];
    enabled : boolean;
    position : LatLong;
    priceAdults : number;
    priceChildren : number;
    category : string;
    hoursBeforeBooking : number;
    isRecurring : boolean;
    recurringFrom : string ;
    recurringTo : string ;
    recurringDays : DayOfWeek[];
    startTime : string;
    endTime : string;
    startDateTime : string ;
    endDateTime : string ;

    constructor() 
    {
            	        super();
		                        this.name = "" ;
                                this.image = new Attachment();
                                this.roundIcon = new Attachment();
                                this.village = new NameIdentifier();
                                this.title = new LocalizedValue();
                                this.caption = new LocalizedValue();
                                this.htmlDescription = new LocalizedValue();
                                this.emailInstructions = new LocalizedValue();
                                this.gallery = [];
                                this.enabled = false ;
                                this.position = new LatLong();
                                this.priceAdults = null ;
                                this.priceChildren = null ;
                                this.category = "" ;
                                this.hoursBeforeBooking = null ;
                                this.isRecurring = false ;
                                this.recurringFrom = null;
                                this.recurringTo = null;
                                this.recurringDays = [];
                                this.startTime = "" ;
                                this.endTime = "" ;
                                this.startDateTime = null;
                                this.endDateTime = null;
                    }
}

export class AddAttachmentVm {
    attachment : Attachment;
    entityIdentifier : string;

    constructor() 
    {
            	                        this.attachment = new Attachment();
                                this.entityIdentifier = "" ;
                    }
}

export class CreateMoneyTransferVm {
    fromUser : string;
    toUser : NameIdentifier;
    importo : number;
    note : string;

    constructor() 
    {
            	                        this.fromUser = "" ;
                                this.toUser = new NameIdentifier();
                                this.importo = null ;
                                this.note = "" ;
                    }
}

export class CreateManualBonusVm {
    toUser : NameIdentifier;
    importo : number;
    note : string;
    date : string ;

    constructor() 
    {
            	                        this.toUser = new NameIdentifier();
                                this.importo = null ;
                                this.note = "" ;
                                this.date = null;
                    }
}

export class TablePagedResultOfBaseWalletTransaction {
    data : BaseWalletTransaction[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class WalletTransactionsListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    dateFrom : string ;
    dateTo : string ;
    user : string;
    amountFrom : number;
    amountTo : number;
    note : string;
    type : string;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.dateFrom = null;
                                this.dateTo = null;
                                this.user = "" ;
                                this.amountFrom = null ;
                                this.amountTo = null ;
                                this.note = "" ;
                                this.type = "" ;
                    }
}

export class WordpressPostVm {
    id : number;
    date : string ;
    title : RenderedContentVm;
    content : RenderedContentVm;
    excerpt : RenderedContentVm;
    link : string;
    status : string;
    embedded : EmbeddedContentVm;

    constructor() 
    {
            	                        this.id = null ;
                                this.date = null;
                                this.title = new RenderedContentVm();
                                this.content = new RenderedContentVm();
                                this.excerpt = new RenderedContentVm();
                                this.link = "" ;
                                this.status = "" ;
                                this.embedded = new EmbeddedContentVm();
                    }
}

export class RenderedContentVm {
    rendered : string;

    constructor() 
    {
            	                        this.rendered = "" ;
                    }
}

export class EmbeddedContentVm {
    featuredMedia : MediaVm[];

    constructor() 
    {
            	                        this.featuredMedia = [];
                    }
}

export class MediaVm {
    id : number;
    sourceUrl : string;
    title : RenderedContentVm;

    constructor() 
    {
            	                        this.id = null ;
                                this.sourceUrl = "" ;
                                this.title = new RenderedContentVm();
                    }
}

export class VillageConfig extends BaseEntity {
    name : string;
    enabled : boolean;
    villageType : string;
    welcomeMessage : LocalizedValue;
    title : LocalizedValue;
    htmlDescription : LocalizedValue;
    telephone : string;
    email : string;
    address : string;
    position : LatLong;
    mapImage : Attachment;
    cardLogo : Attachment;
    cardImage : Attachment;
    cardHtmlDescription : LocalizedValue;
    bannerImage : Attachment;
    logo : Attachment;
    gallery : Attachment[];
    weather : VillageWeather;
    pointsOfInterest : VillagePoi[];
    infoItems : VillageInfoItem[];
    clubVacationBookConfig : ClubVacationBookConfig;

    constructor() 
    {
            	        super();
		                        this.name = "" ;
                                this.enabled = false ;
                                this.villageType = "" ;
                                this.welcomeMessage = new LocalizedValue();
                                this.title = new LocalizedValue();
                                this.htmlDescription = new LocalizedValue();
                                this.telephone = "" ;
                                this.email = "" ;
                                this.address = "" ;
                                this.position = new LatLong();
                                this.mapImage = new Attachment();
                                this.cardLogo = new Attachment();
                                this.cardImage = new Attachment();
                                this.cardHtmlDescription = new LocalizedValue();
                                this.bannerImage = new Attachment();
                                this.logo = new Attachment();
                                this.gallery = [];
                                this.weather = new VillageWeather();
                                this.pointsOfInterest = [];
                                this.infoItems = [];
                                this.clubVacationBookConfig = new ClubVacationBookConfig();
                    }
}

export class VillageWeather {
    description : string;
    temperature : string;
    temperatureMin : string;
    temperatureMax : string;
    feelsLikeTemperature : string;
    humidity : string;
    windSpeed : string;
    iconUrl : string;

    constructor() 
    {
            	                        this.description = "" ;
                                this.temperature = "" ;
                                this.temperatureMin = "" ;
                                this.temperatureMax = "" ;
                                this.feelsLikeTemperature = "" ;
                                this.humidity = "" ;
                                this.windSpeed = "" ;
                                this.iconUrl = "" ;
                    }
}

export class VillagePoi {
    name : string;
    title : LocalizedValue;
    htmlDescription : LocalizedValue;
    gallery : Attachment[];
    category : string;
    position : LatLong;
    openingHours : string;
    externalLinkText : LocalizedValue;
    externalLink : string;

    constructor() 
    {
            	                        this.name = "" ;
                                this.title = new LocalizedValue();
                                this.htmlDescription = new LocalizedValue();
                                this.gallery = [];
                                this.category = "" ;
                                this.position = new LatLong();
                                this.openingHours = "" ;
                                this.externalLinkText = new LocalizedValue();
                                this.externalLink = "" ;
                    }
}

export class VillageInfoItem {
    title : LocalizedValue;
    htmlDescription : LocalizedValue;

    constructor() 
    {
            	                        this.title = new LocalizedValue();
                                this.htmlDescription = new LocalizedValue();
                    }
}

export class ClubVacationBookConfig {
    periods : ClubVacationBookPeriod[];

    constructor() 
    {
            	                        this.periods = [];
                    }
}

export class ClubVacationBookPeriod {
    fromDay : number;
    fromMonth : number;
    toDay : number;
    toMonth : number;

    constructor() 
    {
            	                        this.fromDay = null ;
                                this.fromMonth = null ;
                                this.toDay = null ;
                                this.toMonth = null ;
                    }
}

export class VillageMenuVm {
    villageType : string;
    villages : LocalizedNameIdentifier[];

    constructor() 
    {
            	                        this.villageType = "" ;
                                this.villages = [];
                    }
}

export class LocalizedNameIdentifier {
    identifier : string;
    name : LocalizedValue;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.name = new LocalizedValue();
                    }
}

export class VillageScratchAndWin extends BaseEntity {
    enabled : boolean;
    village : NameIdentifier;
    backgroundImage : Attachment;
    winnableItems : WinnableItem[];

    constructor() 
    {
            	        super();
		                        this.enabled = false ;
                                this.village = new NameIdentifier();
                                this.backgroundImage = new Attachment();
                                this.winnableItems = [];
                    }
}

export class WinnableItem {
    name : string;
    image : Attachment;
    title : LocalizedValue;
    htmlDescription : LocalizedValue;
    quantity : number;
    availableFrom : string ;
    availableTo : string ;

    constructor() 
    {
            	                        this.name = "" ;
                                this.image = new Attachment();
                                this.title = new LocalizedValue();
                                this.htmlDescription = new LocalizedValue();
                                this.quantity = null ;
                                this.availableFrom = null;
                                this.availableTo = null;
                    }
}

export class VillageScratchAndWinPlay extends BaseEntity {
    user : NameIdentifier;
    village : NameIdentifier;
    itemWon : WonItem;
    scratchedOn : string ;
    redeemedOn : string ;

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.village = new NameIdentifier();
                                this.itemWon = new WonItem();
                                this.scratchedOn = null;
                                this.redeemedOn = null;
                    }
}

export class WonItem {
    name : string;
    image : Attachment;
    title : LocalizedValue;
    htmlDescription : LocalizedValue;

    constructor() 
    {
            	                        this.name = "" ;
                                this.image = new Attachment();
                                this.title = new LocalizedValue();
                                this.htmlDescription = new LocalizedValue();
                    }
}

export class TablePagedResultOfClubVacationBooking {
    data : ClubVacationBooking[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class ClubVacationBooking extends BaseEntity {
    user : NameIdentifier;
    village : NameIdentifier;
    fromDate : string ;
    toDate : string ;
    status : string;
    bookingNumber : string;
    adultsCount : number;
    childrenCount : number;
    childrenAges : number[];

    constructor() 
    {
            	        super();
		                        this.user = new NameIdentifier();
                                this.village = new NameIdentifier();
                                this.fromDate = null;
                                this.toDate = null;
                                this.status = "" ;
                                this.bookingNumber = "" ;
                                this.adultsCount = null ;
                                this.childrenCount = null ;
                                this.childrenAges = [];
                    }
}

export class ClubVacationBookingListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    createdOnFrom : string ;
    createdOnTo : string ;
    bookingNumber : string;
    fromDateFrom : string ;
    fromDateTo : string ;
    toDateFrom : string ;
    toDateTo : string ;
    status : string;
    user : string;
    village : string;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.createdOnFrom = null;
                                this.createdOnTo = null;
                                this.bookingNumber = "" ;
                                this.fromDateFrom = null;
                                this.fromDateTo = null;
                                this.toDateFrom = null;
                                this.toDateTo = null;
                                this.status = "" ;
                                this.user = "" ;
                                this.village = "" ;
                    }
}

export class NewVacationBookingVm {
    clubVacationVoucherIdentifier : string;
    userIdentifier : string;
    villageIdentifier : string;
    fromDate : string ;
    toDate : string ;
    adultsCount : number;
    childrenCount : number;
    childrenAges : number[];

    constructor() 
    {
            	                        this.clubVacationVoucherIdentifier = "" ;
                                this.userIdentifier = "" ;
                                this.villageIdentifier = "" ;
                                this.fromDate = null;
                                this.toDate = null;
                                this.adultsCount = null ;
                                this.childrenCount = null ;
                                this.childrenAges = [];
                    }
}

export class RemainingBookingWeeksVm {
    totalWeeks : number;
    bookedWeeks : number;

    constructor() 
    {
            	                        this.totalWeeks = null ;
                                this.bookedWeeks = null ;
                    }
}

export class ClubVacationBookingVm {
    identifier : string;
    user : NameIdentifier;
    village : LocalizedNameIdentifier;
    fromDate : string ;
    toDate : string ;
    status : string;
    bookingNumber : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.user = new NameIdentifier();
                                this.village = new LocalizedNameIdentifier();
                                this.fromDate = null;
                                this.toDate = null;
                                this.status = "" ;
                                this.bookingNumber = "" ;
                    }
}

export class ClubVacationBookingActionVm {
    clubVacationBookingIdentifier : string;
    sendMail : boolean;
    sendNotification : boolean;
    message : string;

    constructor() 
    {
            	                        this.clubVacationBookingIdentifier = "" ;
                                this.sendMail = false ;
                                this.sendNotification = false ;
                                this.message = "" ;
                    }
}

export class ShopCategory extends BaseEntity {
    name : string;
    enabled : boolean;
    title : LocalizedValue;
    image : Attachment;
    displayOrder : number;
    useOfferRequirements : boolean;
    isUpsellCategory : boolean;
    isEntryCategory : boolean;
    isOfferteRiservateSoci : boolean;

    constructor() 
    {
            	        super();
		                        this.name = "" ;
                                this.enabled = false ;
                                this.title = new LocalizedValue();
                                this.image = new Attachment();
                                this.displayOrder = null ;
                                this.useOfferRequirements = false ;
                                this.isUpsellCategory = false ;
                                this.isEntryCategory = false ;
                                this.isOfferteRiservateSoci = false ;
                    }
}

export class ShopOffer extends BaseEntity {
    name : string;
    title : LocalizedValue;
    subTitle : LocalizedValue;
    htmlShortDescription : LocalizedValue;
    htmlDescription : LocalizedValue;
    category : NameIdentifier;
    products : NameIdentifier[];
    priceConfig : PriceConfig;
    rewardConfig : RewardConfig;
    image : Attachment;
    displayOrder : number;
    rolesFilter : string[];
    clubSubscriptionTierFilter : number[];
    enabled : boolean;
    minProductLevelRequired : number;
    maxProductLevelRequired : number;
    applyProductLevel : boolean;
    productLevelApplied : number;
    upsellOffers : NameIdentifier[];
    appleIapId : string;
    repurchasable : boolean;
    paymentMethodsAllowed : string[];
    productsRequiredForVisibility : NameIdentifier[];
    isPopular : boolean;
    useBuyForm : boolean;
    formItems : FormItemConfig[];

    constructor() 
    {
            	        super();
		                        this.name = "" ;
                                this.title = new LocalizedValue();
                                this.subTitle = new LocalizedValue();
                                this.htmlShortDescription = new LocalizedValue();
                                this.htmlDescription = new LocalizedValue();
                                this.category = new NameIdentifier();
                                this.products = [];
                                this.priceConfig = new PriceConfig();
                                this.rewardConfig = new RewardConfig();
                                this.image = new Attachment();
                                this.displayOrder = null ;
                                this.rolesFilter = [];
                                this.clubSubscriptionTierFilter = [];
                                this.enabled = false ;
                                this.minProductLevelRequired = null ;
                                this.maxProductLevelRequired = null ;
                                this.applyProductLevel = false ;
                                this.productLevelApplied = null ;
                                this.upsellOffers = [];
                                this.appleIapId = "" ;
                                this.repurchasable = false ;
                                this.paymentMethodsAllowed = [];
                                this.productsRequiredForVisibility = [];
                                this.isPopular = false ;
                                this.useBuyForm = false ;
                                this.formItems = [];
                    }
}

export class FormItemConfig {
    name : string;
    label : LocalizedValue;
    required : boolean;
    isSelect : boolean;
    isMultiSelect : boolean;
    options : LocalizedValue[];

    constructor() 
    {
            	                        this.name = "" ;
                                this.label = new LocalizedValue();
                                this.required = false ;
                                this.isSelect = false ;
                                this.isMultiSelect = false ;
                                this.options = [];
                    }
}

export class ShopFullTextSearchResultVm {
    categories : ShopCategory[];
    offers : ShopOffer[];

    constructor() 
    {
            	                        this.categories = [];
                                this.offers = [];
                    }
}

export class InterpolationTemplate extends BaseEntity {
    subject : LocalizedValue2;
    text : LocalizedValue2;
    defaultLanguage : string;
    useRawHtmlEditor : boolean;
    eventName : string;
    additionalCc : string[];
    additionalBcc : string[];

    constructor() 
    {
            	        super();
		                        this.subject = new LocalizedValue2();
                                this.text = new LocalizedValue2();
                                this.defaultLanguage = "" ;
                                this.useRawHtmlEditor = false ;
                                this.eventName = "" ;
                                this.additionalCc = [];
                                this.additionalBcc = [];
                    }
}

export class LocalizedValue2 {
    values : { [key: string]: string; };

    constructor() 
    {
            	                        this.values = {};
                    }
}

export class SmsTemplate extends BaseEntity {
    text : LocalizedValue3;
    eventName : string;
    defaultLanguage : string;

    constructor() 
    {
            	        super();
		                        this.text = new LocalizedValue3();
                                this.eventName = "" ;
                                this.defaultLanguage = "" ;
                    }
}

export class LocalizedValue3 {
    values : { [key: string]: string; };

    constructor() 
    {
            	                        this.values = {};
                    }
}

export class BaseUser extends BaseEntity {
    personalData : PersonalData;
    contactData : ContactData;
    fiscalData : FiscalData;
    authData : AuthData;
    marketingOptions : MarketingOptions;
    referralCode : string;
    productLevel : number;
    networkParentNode : NameIdentifier;
    networkParentNodeHistory : DateValueOfNodeAssignment[];
    note : Comment[];
    list : string;
    statuses : Statuses;
    selectedVillage : NameIdentifier;
    preferredCulture : string;
    role : string;
    type : string;
    linkedAccounts : NameIdentifier[];
    lastLoginOn : string ;
    currentPosition : PositionHistoryItem;
    positionHistory : PositionHistoryItem[];
    qualifications : Qualification[];
    notificationSettings : NotificationSettings;
    fullAccess : boolean;
    obliviedOn : string ;
    fcmIds : string[];

    constructor() 
    {
            	        super();
		                        this.personalData = new PersonalData();
                                this.contactData = new ContactData();
                                this.fiscalData = new FiscalData();
                                this.authData = new AuthData();
                                this.marketingOptions = new MarketingOptions();
                                this.referralCode = "" ;
                                this.productLevel = null ;
                                this.networkParentNode = new NameIdentifier();
                                this.networkParentNodeHistory = [];
                                this.note = [];
                                this.list = "" ;
                                this.statuses = new Statuses();
                                this.selectedVillage = new NameIdentifier();
                                this.preferredCulture = "" ;
                                this.role = "" ;
                                this.type = "" ;
                                this.linkedAccounts = [];
                                this.lastLoginOn = null;
                                this.currentPosition = new PositionHistoryItem();
                                this.positionHistory = [];
                                this.qualifications = [];
                                this.notificationSettings = new NotificationSettings();
                                this.fullAccess = false ;
                                this.obliviedOn = null;
                                this.fcmIds = [];
                    }
}

export class AuthData {
    username : string;
    password : string;
    tempPassword : string;
    tokenForResetPassword : string;
    passwordExpirationDate : string ;
    loginEnabled : boolean;
    authProviders : string[];

    constructor() 
    {
            	                        this.username = "" ;
                                this.password = "" ;
                                this.tempPassword = "" ;
                                this.tokenForResetPassword = "" ;
                                this.passwordExpirationDate = null;
                                this.loginEnabled = false ;
                                this.authProviders = [];
                    }
}

export class MarketingOptions {
    marketing : boolean;
    reviews : boolean;

    constructor() 
    {
            	                        this.marketing = false ;
                                this.reviews = false ;
                    }
}

export class DateValueOfNodeAssignment {
    date : string ;
    value : NodeAssignment;

    constructor() 
    {
            	                        this.date = null;
                                this.value = new NodeAssignment();
                    }
}

export class NodeAssignment {
    assigner : NameIdentifier;
    assigned : NameIdentifier;
    reason : string;

    constructor() 
    {
            	                        this.assigner = new NameIdentifier();
                                this.assigned = new NameIdentifier();
                                this.reason = "" ;
                    }
}

export class Statuses {
    status : string;
    statusHistory : DateValueOfStatusChange[];
    subStatus : string;
    subStatusHistory : DateValueOfStatusChange[];
    scadenze : ToDo[];

    constructor() 
    {
            	                        this.status = "" ;
                                this.statusHistory = [];
                                this.subStatus = "" ;
                                this.subStatusHistory = [];
                                this.scadenze = [];
                    }
}

export class DateValueOfStatusChange {
    date : string ;
    value : StatusChange;

    constructor() 
    {
            	                        this.date = null;
                                this.value = new StatusChange();
                    }
}

export class StatusChange {
    identifier : string;
    author : NameIdentifier;
    from : string;
    to : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.author = new NameIdentifier();
                                this.from = "" ;
                                this.to = "" ;
                    }
}

export class ToDo {
    identifier : string;
    createdOn : string ;
    startDate : string ;
    endDate : string ;
    author : NameIdentifier;
    text : string;
    toDoType : string;
    attachments : Attachment[];
    status : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.createdOn = null;
                                this.startDate = null;
                                this.endDate = null;
                                this.author = new NameIdentifier();
                                this.text = "" ;
                                this.toDoType = "" ;
                                this.attachments = [];
                                this.status = "" ;
                    }
}

export class PositionHistoryItem {
    geo : GeoJsonPointOfGeoJson2DCoordinates;
    date : string ;

    constructor() 
    {
            	                        this.geo = new GeoJsonPointOfGeoJson2DCoordinates();
                                this.date = null;
                    }
}

export class GeoJsonPointOfGeoJson2DCoordinates {
    [key: string]: any; 

    constructor() 
    {
            	            }
}

export class NotificationSettings {
    helpCenter : boolean;
    village : boolean;
    network : boolean;
    wallet : boolean;

    constructor() 
    {
            	                        this.helpCenter = false ;
                                this.village = false ;
                                this.network = false ;
                                this.wallet = false ;
                    }
}

export class NameIdentifierCode extends NameIdentifier {
    code : string;

    constructor() 
    {
            	        super();
		                        this.code = "" ;
                    }
}

export class NewUserCountersVm {
    newUsersToday : number;
    newUsersThisWeek : number;
    newUsersThisMonth : number;
    newSubsToday : number;
    newSubsThisWeek : number;
    newSubsThisMonth : number;
    newAgentsToday : number;
    newAgentsThisWeek : number;
    newAgentsThisMonth : number;

    constructor() 
    {
            	                        this.newUsersToday = null ;
                                this.newUsersThisWeek = null ;
                                this.newUsersThisMonth = null ;
                                this.newSubsToday = null ;
                                this.newSubsThisWeek = null ;
                                this.newSubsThisMonth = null ;
                                this.newAgentsToday = null ;
                                this.newAgentsThisWeek = null ;
                                this.newAgentsThisMonth = null ;
                    }
}

export class AssignToVm {
    userIdentifier : string;
    assignTo : NameIdentifier;

    constructor() 
    {
            	                        this.userIdentifier = "" ;
                                this.assignTo = new NameIdentifier();
                    }
}

export class PositionHistoryItemVm {
    lat : number;
    lng : number;
    date : string ;

    constructor() 
    {
            	                        this.lat = null ;
                                this.lng = null ;
                                this.date = null;
                    }
}

export class AddFcmIdVm {
    userIdentifier : string;
    fcmId : string;

    constructor() 
    {
            	                        this.userIdentifier = "" ;
                                this.fcmId = "" ;
                    }
}

export class CompleteProfileVm {
    identifier : string;
    name : string;
    surname : string;
    country : string;
    telephone : Telephone;
    birthDate : string ;
    marketingOptions : MarketingOptions;
    referralCode : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.name = "" ;
                                this.surname = "" ;
                                this.country = "" ;
                                this.telephone = new Telephone();
                                this.birthDate = null;
                                this.marketingOptions = new MarketingOptions();
                                this.referralCode = "" ;
                    }
}

export class ActivateOfferOnMultipleCustomersVm {
    customerList : string[];
    shopOfferIdentifier : string;

    constructor() 
    {
            	                        this.customerList = [];
                                this.shopOfferIdentifier = "" ;
                    }
}

export class TablePagedResultOfBaseUserTableVm {
    data : BaseUserTableVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class BaseUserTableVm {
    identifier : string;
    createdOn : string ;
    lastLoginOn : string ;
    contactName : string;
    name : string;
    surname : string;
    email : string;
    telephone : string;
    networkParentNode : NameIdentifier;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.createdOn = null;
                                this.lastLoginOn = null;
                                this.contactName = "" ;
                                this.name = "" ;
                                this.surname = "" ;
                                this.email = "" ;
                                this.telephone = "" ;
                                this.networkParentNode = new NameIdentifier();
                    }
}

export class BaseUserListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    createdOn : string ;
    contactName : string;
    name : string;
    surname : string;
    email : string;
    telephone : string;
    networkParentUser : string;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.createdOn = null;
                                this.contactName = "" ;
                                this.name = "" ;
                                this.surname = "" ;
                                this.email = "" ;
                                this.telephone = "" ;
                                this.networkParentUser = "" ;
                    }
}

export class BaseUserFilterForPushVm extends BasePagedRequest {
    userIdentifier : string;
    createdOnFrom : string ;
    createdOnTo : string ;
    lastLoginOnFrom : string ;
    lastLoginOnTo : string ;
    contactName : string;
    email : string;
    telephone : string;
    networkParentUserIdentifier : string;
    includeDescendants : boolean;
    clubSubscriptionActive : boolean;
    agentSubscriptionActive : boolean;
    villageIdentifier : string;
    distanceFromVillage : number;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.createdOnFrom = null;
                                this.createdOnTo = null;
                                this.lastLoginOnFrom = null;
                                this.lastLoginOnTo = null;
                                this.contactName = "" ;
                                this.email = "" ;
                                this.telephone = "" ;
                                this.networkParentUserIdentifier = "" ;
                                this.includeDescendants = false ;
                                this.clubSubscriptionActive = false ;
                                this.agentSubscriptionActive = false ;
                                this.villageIdentifier = "" ;
                                this.distanceFromVillage = null ;
                    }
}

export class Lead extends BaseUser {

    constructor() 
    {
            	        super();
		            }
}

export class Operator extends Lead {
    paymentData : UserPaymentData;

    constructor() 
    {
            	        super();
		                        this.paymentData = new UserPaymentData();
                    }
}

export class UpdateAddressVm {
    identifier : string;
    address : Address;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.address = new Address();
                    }
}

export class UpdateLuogoDataNascitaVm {
    identifier : string;
    luogo : string;
    dataNascita : string ;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.luogo = "" ;
                                this.dataNascita = null;
                    }
}

export class UpdatePersonalDataVm {
    identifier : string;
    data : PersonalData;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.data = new PersonalData();
                    }
}

export class UpdateFiscalDataVm {
    identifier : string;
    data : FiscalData;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.data = new FiscalData();
                    }
}

export class ResetPasswordVm {
    email : string;
    password : string;
    token : string;

    constructor() 
    {
            	                        this.email = "" ;
                                this.password = "" ;
                                this.token = "" ;
                    }
}

export class LeadAssignmentHistoryVm {
    lead : NameIdentifier;
    storicoAssegnazione : DateValueOfNodeAssignment;

    constructor() 
    {
            	                        this.lead = new NameIdentifier();
                                this.storicoAssegnazione = new DateValueOfNodeAssignment();
                    }
}

export class ScadenzeLeadVm {
    toDos : LeadToDoVm[];

    constructor() 
    {
            	                        this.toDos = [];
                    }
}

export class LeadToDoVm {
    identifier : string;
    project : string;
    contactName : string;
    name : string;
    type : string;
    scadenza : ToDo;
    status : string;
    toDoType : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.project = "" ;
                                this.contactName = "" ;
                                this.name = "" ;
                                this.type = "" ;
                                this.scadenza = new ToDo();
                                this.status = "" ;
                                this.toDoType = "" ;
                    }
}

export class MultipleLeadsActionVm {
    leadList : string[];
    userIdentifier : string;
    value : string;

    constructor() 
    {
            	                        this.leadList = [];
                                this.userIdentifier = "" ;
                                this.value = "" ;
                    }
}

export class CheckEmailVm {
    identifier : string;
    email : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.email = "" ;
                    }
}

export class CheckNumberVm {
    identifier : string;
    telephone : Telephone;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.telephone = new Telephone();
                    }
}

export class TablePagedResultOfLeadTableVm {
    data : LeadTableVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
            	                        this.data = [];
                                this.count = null ;
                                this.pageNumber = null ;
                                this.perPage = null ;
                    }
}

export class LeadTableVm {
    identifier : string;
    createdOn : string ;
    lastLoginOn : string ;
    qualification : Qualification;
    type : string;
    contactName : string;
    name : string;
    surname : string;
    username : string;
    email : string;
    telephone : string;
    status : string;
    subStatus : string;
    subscriptionRole : string;
    networkParentNode : NameIdentifier;
    scadenze : ToDo[];
    role : string;

    constructor() 
    {
            	                        this.identifier = "" ;
                                this.createdOn = null;
                                this.lastLoginOn = null;
                                this.qualification = new Qualification();
                                this.type = "" ;
                                this.contactName = "" ;
                                this.name = "" ;
                                this.surname = "" ;
                                this.username = "" ;
                                this.email = "" ;
                                this.telephone = "" ;
                                this.status = "" ;
                                this.subStatus = "" ;
                                this.subscriptionRole = "" ;
                                this.networkParentNode = new NameIdentifier();
                                this.scadenze = [];
                                this.role = "" ;
                    }
}

export class LeadListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    selectedList : string;
    showLead : boolean;
    showSoci : boolean;
    showIncaricati : boolean;
    showTelephoneOnly : boolean;
    createdOn : string ;
    contactName : string;
    name : string;
    surname : string;
    qualifica : string;
    telephone : string;
    email : string;
    status : string;
    networkParentUser : string;

    constructor() 
    {
            	        super();
		                        this.userIdentifier = "" ;
                                this.selectedList = "" ;
                                this.showLead = false ;
                                this.showSoci = false ;
                                this.showIncaricati = false ;
                                this.showTelephoneOnly = false ;
                                this.createdOn = null;
                                this.contactName = "" ;
                                this.name = "" ;
                                this.surname = "" ;
                                this.qualifica = "" ;
                                this.telephone = "" ;
                                this.email = "" ;
                                this.status = "" ;
                                this.networkParentUser = "" ;
                    }
}

export class LeadList extends BaseEntity {
    value : string;

    constructor() 
    {
            	        super();
		                        this.value = "" ;
                    }
}

export class CreateUserVm {
    name : string;
    surname : string;
    email : string;
    password : string;
    username : string;
    referralCode : string;
    loginEnabled : boolean;

    constructor() 
    {
            	                        this.name = "" ;
                                this.surname = "" ;
                                this.email = "" ;
                                this.password = "" ;
                                this.username = "" ;
                                this.referralCode = "" ;
                                this.loginEnabled = false ;
                    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}